
import RaceClock from './race-clock'
export default
  name: 'timing-board'
  components: { RaceClock }
  props:
    header: String
    href: String
    slug: String
    tag: String
    initial_timers: Array
  data: ->
    timers: []
  methods:
    refresh: ->
      @axios.get(@href)
        .then (res) => @timers = res.data.timers
        .catch (e) -> console.log e

  mounted: ->
#    @refresh()
    @timers = @initial_timers
    @$root.$cable.subscribe({ channel: 'TimingBoardChannel', slug: @slug })

  channels:
    TimingBoardChannel:
      received: (data) ->
        if @tag?
          timers = data.timers.filter((x) => x.tags? && x.tags.split(/[ ,]/).includes(@tag))
        else
          timers = data.timers
        @$set(@, 'timers', timers)

